// extracted by mini-css-extract-plugin
export default {"title":"ThankYou_title__OVpj9","subtitle":"ThankYou_subtitle__rBdvI","circle":"ThankYou_circle__vFY5U"};